<div class="modal-confirmacion-root" (keydown.escape)="cerrarConEscape($event)">
<h1 *ngIf="objeto.novedadesConfirmacion" mat-dialog-title id="novedades-confirm-title" class="novedades-confirm-header">
  <span>{{ objeto.esSeleccion ? 'Justificar Aviso Humand' : 'Confirmación' }}</span>
  <button type="button" class="novedades-confirm-close" aria-label="Cerrar" (click)="cerrarModal(false)">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>
</h1>

<h1 *ngIf="!objeto.novedadesConfirmacion" mat-dialog-title class="bg-primary titulo-modal">
  {{ objeto.esSeleccion ? 'Justificar Aviso Humand' : 'Confirmación' }}
  <mat-icon class="btn-close" (click)="cerrarModal(false)">clear</mat-icon>
</h1>

<div *ngIf="objeto.novedadesConfirmacion" mat-dialog-content class="novedades-confirm-body" id="novedades-confirm-message">
  <span class="novedades-confirm-icon" aria-hidden="true">
    <mat-icon>help_outline</mat-icon>
  </span>
  <p>{{ objeto.titulo }}</p>
</div>

<div *ngIf="!objeto.novedadesConfirmacion" mat-dialog-content class="p-3">
  <!-- Info de fechas (si existe) -->
  <mat-card class="mb-3 info-fechas" *ngIf="objeto.infoFechas">
    <div class="row text-center">
      <div class="col-3">
        <mat-label class="label-fecha">Desde</mat-label>
        <p class="valor-fecha">{{ objeto.infoFechas.desde | date:'dd/MM/yyyy' }}</p>
      </div>
      <div class="col-3">
        <mat-label class="label-fecha">Hasta</mat-label>
        <p class="valor-fecha">{{ objeto.infoFechas.hasta | date:'dd/MM/yyyy' }}</p>
      </div>
      <div class="col-3">
        <mat-label class="label-fecha">Días</mat-label>
        <p class="valor-fecha">{{ objeto.infoFechas.dias }}</p>
      </div>
      <div class="col-3">
        <mat-label class="label-fecha">Retorno</mat-label>
        <p class="valor-fecha">{{ objeto.infoFechas.retorno | date:'dd/MM/yyyy' }}</p>
      </div>
    </div>
  </mat-card>

  <!-- Modo simple: confirmación con texto -->
  <div *ngIf="!objeto.esSeleccion">
    <!-- Mensaje principal solo si NO hay advertencia ZK -->
    <p class="mensaje-confirmacion" *ngIf="!objeto.tieneAdvertenciaZK">{{ objeto.titulo }}</p>
    
    <!-- Si tiene advertencia ZK, solo mostrar la tarjeta amarilla -->
    <div *ngIf="objeto.tieneAdvertenciaZK">
      <p class="mensaje-confirmacion mb-3">{{ objeto.titulo }}</p>
      <mat-card class="advertencia-zk">
        <mat-icon class="icono-advertencia">warning</mat-icon>
        <div class="texto-advertencia">
          <strong>Sincronización de Terminales ZK</strong>
          <p>Los equipos se bloquearán momentáneamente durante la sincronización de nómina y templates de huellas digitales.</p>
        </div>
      </mat-card>
    </div>
  </div>

  <!-- Modo selección: radio buttons -->
  <div *ngIf="objeto.esSeleccion">
    <p class="mb-3"><strong>{{ objeto.titulo }}</strong></p>
    
    <mat-radio-group [(ngModel)]="opcionSeleccionada" (change)="onSeleccionIncidencia($event)" class="d-flex flex-column">
      <mat-radio-button 
        *ngFor="let opcion of objeto.opciones" 
        [value]="opcion.Id"
        class="mb-2">
        {{ opcion.Detalle }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <!-- Selector de Patología (condicional) -->
  <div *ngIf="mostrarSelectorPatologia" class="mt-3">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Patología *</mat-label>
      <mat-select [(ngModel)]="patologiaSeleccionada" (selectionChange)="onSeleccionPatologia($event)">
        <mat-option [value]="0">-- Seleccione --</mat-option>
        <mat-option *ngFor="let patologia of objeto.patologias" [value]="patologia.Id">
          {{ patologia.Detalle }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div *ngIf="!objeto.novedadesConfirmacion" mat-dialog-actions class="justify-content-end p-3">
  <button mat-stroked-button color="warn" (click)="cerrarModal(false)">
    {{ objeto.esSeleccion ? 'Cancelar' : 'No' }}
  </button>
  <button mat-raised-button color="primary" (click)="cerrarModal(true)" cdkFocusInitial>
    {{ objeto.esSeleccion ? 'Justificar' : 'Si' }}
  </button>
</div>

<div *ngIf="objeto.novedadesConfirmacion" mat-dialog-actions class="novedades-confirm-actions">
  <button type="button" class="novedades-confirm-button novedades-confirm-no" (click)="cerrarModal(false)">No</button>
  <button type="button" class="novedades-confirm-button novedades-confirm-yes" (click)="cerrarModal(true)" cdkFocusInitial>Sí</button>
</div>
</div>
